import React from 'react';
import PropTypes from 'prop-types';

import style from './index.module.scss';

function AnswerPrompt({ currentUser, displayAnswerForm }) {
  return (
    <div className={`row ${style['answer-prompt']}`}>
      <div className={`col-12 ${style.col}`}>
        <img 
        	className={style.img} 
        	src={currentUser.imgUrl || 'https://i.imgur.com/qHpJwKV.jpg'} 
        	alt={currentUser.fullname} 
        />
        <p className={`${style['user-msg']} ${style['user-msg--one']}`}>
          {currentUser.firstname}, can you answer this question?
        </p>
        <p className={`${style['user-msg']} ${style['user-msg--two']}`}>
          People are searching for a better answer to this question.
        </p>
        <button
          className={style['btn--answer']}
          onClick={displayAnswerForm}
        >
          <i className="fas fa-pencil-alt" /> Answer
        </button>
      </div>
    </div>
  );
}

AnswerPrompt.propTypes = {
	currentUser: PropTypes.shape({
		firstname: PropTypes.string.isRequired,
		fullname: PropTypes.string.isRequired,
	}).isRequired,
  displayAnswerForm: PropTypes.func.isRequired,
};

export default AnswerPrompt;
